import { render, staticRenderFns } from "./EditJob.vue?vue&type=template&id=64cebba8&"
import script from "./EditJob.vue?vue&type=script&lang=js&"
export * from "./EditJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports